module.exports = function () {

    let module = {};

    let maps = [
        'map-container',
        'map-container-2'
    ];

    let map;
    let marker;

    // Declare image dimensions
    let marker_size = [60 * 2, 60 * 2];

    module.init = function ($map_id) {

        // Work out which options to choose
        // If a class is present use those options
        // otherwise use default


        var options = {
            zoom: 11,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            scrollwheel: false,
            styles: [
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e9e9e9"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#333333"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                }
            ]
        };

        if ($('#' + $map_id).length) map = new google.maps.Map(document.getElementById($map_id), options);


        var image = {
            url: '/images/mapmarker.png',
            size: new google.maps.Size(marker_size[0], marker_size[1]),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, marker_size[1] / 2),
            scaledSize: new google.maps.Size(marker_size[0] / 2, marker_size[1] / 2)
        };

        marker = new google.maps.Marker({
            map: map,
            animation: google.maps.Animation.DROP,
            icon: image,
            optimized: false

        });


        // Resize stuff...
        google.maps.event.addDomListener(window, "resize", function () {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });

    };

    module.assign = function () {

// Array to store references to info windows
        var infoWindows = [];

        $.each(maps, function (index, value) {


            let $map_id = value;

            if ($('#' + $map_id).length) {


                module.init($map_id);

                $lat = $('#' + $map_id).data('lat');
                $lng = $('#' + $map_id).data('long');
                $zoom = $('#' + $map_id).data('zoom');

                // JSON array of map data
                $json = $('#' + $map_id).data('json');


                var image = {
                    url: '/images/mapmarker.png',
                    size: new google.maps.Size(marker_size[0], marker_size[1]),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(20, marker_size[1] / 2),
                    scaledSize: new google.maps.Size(marker_size[0] / 2, marker_size[1] / 2)
                };


                // Array of placemarkers in JSON format

                if ($json) {
                    var points = $json;


                    //create empty LatLngBounds object
                    var bounds = new google.maps.LatLngBounds();


                    $.each(points, function ($k, $v) {

                        var loc = new google.maps.LatLng($v.latitude, $v.longitude);
                        //console.log(loc);

                        if ($('#map-container').hasClass('properties')) {
                            // Create content for the infowindow
                            var content = '<div class="map-infowindow">' +
                                '<div class="row">' +
                                '<div class="col-sm-4">' +
                                '<img src="' + $v.image + '" class="img-fluid w-100" alt="' + $v.title + '">' +
                                '</div>' +
                                '<div class="col-sm-8">' +
                                '<h3>' + $v.title + '</h3>' +
                                '<p>' + $v.summary + '</p>' +
                                '<a href="' + $v.url + '" class="btn btn-sm btn-primary">View Details</a>' +
                                '</div>' +
                                '</div>';


                            var infowindow = new google.maps.InfoWindow({
                                content: content
                            });
                            // Push the current info window to the array
                            infoWindows.push(infowindow);
                        }

                        marker = new google.maps.Marker({
                            map: map,
                            animation: google.maps.Animation.DROP,
                            icon: image,
                            url: $v.url,
                            position: loc,
                            title: $v.title
                        });

                        //extend the bounds to include each marker's position
                        bounds.extend(marker.position);

                        if ($('#map-container').hasClass('properties')) {


                            // Add click event listener to marker to open infowindow
                            marker.addListener('click', function () {
                                infowindow.open(map, marker);
                            });

                            // Close infowindow when map is clicked
                            map.addListener('click', function () {
                                infowindow.close();
                            });

                            google.maps.event.addListener(marker, 'click', (function (marker) {
                                return function () {

                                    // Close all existing info windows
                                    infoWindows.forEach(function (infowindow) {
                                        infowindow.close();
                                    });

                                    infowindow.open(map, marker);
                                }
                            })(marker));

                        }
                        else{
                            marker.addListener('click', function () {
                                window.location = $v.url;
                            });
                        }



                        // google.maps.event.addListener(marker, 'click', function () {
                        //     window.location.href = this.url;
                        // });

                        marker.setPosition(loc);
                    });

                    //now fit the map to the newly inclusive bounds
                    map.fitBounds(bounds);

                }
                // Single point
                else {

                    var location = new google.maps.LatLng($lat, $lng);
                    google.maps.event.trigger(map, 'resize');
                    marker.setPosition(location);
                    map.setCenter(location);
                    map.setZoom($zoom);
                }
            }


        });


    };

    return module;

};
